import fly from "../config/flyio";

export default {
  // 初始化
  initializing(data) {
    return fly.post("/VHISLoveYourSelf/Initializing", data);
  },
  // 前一页
  previousPage(data) {
    return fly.post("/VHISLoveYourSelf/PreviousPage", data);
  },
  // 后一页
  nextPage(data) {
    return fly.post("/VHISLoveYourSelf/NextPage", data);
  },
  // 从apply去confirm
  goConfirmPage(data) {
    return fly.post("/VHISLoveYourSelf/Apply",data);
  },
  getDisplayAction(data){
    return fly.post("/VHISLoveYourSelf/DisplayPage",data);
  },

  getApplicantForConfirm(data){
    return fly.get(`/VHISLoveYourSelf/GetApplicantForConfirm?AppNo=${data}`);
  },
  declarationSubmit(data){
    return fly.post("/VHISLoveYourSelf/DeclarationSubmit",data);
  },
  confirmPremiumDisply(data){
    const p ="?AppNo="+data[0]+"&lang="+data[1];
    return fly.get("VHISLoveYourSelf/ConfirmPremiumDisply"+p);
  },
  CheckUWcase(data){
    const p ="?AppNo="+data[0];
    return fly.get("VHISLoveYourSelf/CheckUWCase"+p);
  }
  
};
